import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { BannerImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/bannerImpression.trackingInfo";

import {
    getJsonPayload,
    getPageInfo,
    getUserInfo
} from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: BannerImpressionTrackingInfo) => {
    const event: TypedAnalyticsEvent<BannerImpressionTrackingInfo> = {
        event: EventType.BannerImpression,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo);
};
